var _path, _path2, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIstoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_on_the_App_Store_Badge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 168.504,
    height: 49.927,
    viewBox: "0 0 168.504 49.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9865",
    "data-name": "Path 9865",
    d: "M162.509,49.927H5.9A5.916,5.916,0,0,1,0,44.02V5.9A5.908,5.908,0,0,1,5.9,0H162.509A5.988,5.988,0,0,1,168.5,5.9V44.02a6,6,0,0,1-5.995,5.908Z",
    fill: "#a6a6a6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9866",
    "data-name": "Path 9866",
    d: "M167.075,43.8a4.78,4.78,0,0,1-4.786,4.781H5.682A4.787,4.787,0,0,1,.89,43.8V5.677A4.793,4.793,0,0,1,5.682.89H162.288a4.786,4.786,0,0,1,4.786,4.787V43.8Z",
    transform: "translate(0.221 0.221)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7670",
    "data-name": "Group 7670",
    transform: "translate(15.967 7.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7669",
    "data-name": "Group 7669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9867",
    "data-name": "Path 9867",
    d: "M34.43,21.624a7.235,7.235,0,0,1,3.446-6.071A7.411,7.411,0,0,0,32.04,12.4c-2.455-.258-4.837,1.469-6.087,1.469-1.276,0-3.2-1.444-5.277-1.4a7.77,7.77,0,0,0-6.54,3.989c-2.828,4.9-.719,12.092,1.991,16.05,1.356,1.938,2.939,4.1,5.013,4.027,2.028-.084,2.786-1.293,5.234-1.293,2.425,0,3.137,1.293,5.251,1.244,2.177-.035,3.547-1.947,4.855-3.9A16.017,16.017,0,0,0,38.7,28.057,6.994,6.994,0,0,1,34.43,21.624Z",
    transform: "translate(-12.792 -4.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9868",
    "data-name": "Path 9868",
    d: "M27.876,11.321a7.122,7.122,0,0,0,1.63-5.1,7.255,7.255,0,0,0-4.691,2.426,6.778,6.778,0,0,0-1.673,4.915A5.992,5.992,0,0,0,27.876,11.321Z",
    transform: "translate(-10.232 -6.217)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7671",
    "data-name": "Group 7671",
    transform: "translate(52.935 22.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9869",
    "data-name": "Path 9869",
    d: "M56.433,34.807H53.6l-1.553-4.879h-5.4L45.17,34.807H42.41L47.757,18.2h3.3Zm-4.855-6.926-1.4-4.337q-.223-.665-.838-3.129h-.05q-.245,1.06-.789,3.129l-1.379,4.337Z",
    transform: "translate(-42.41 -17.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9870",
    "data-name": "Path 9870",
    d: "M66.955,27.8A6.806,6.806,0,0,1,65.3,32.628a4.828,4.828,0,0,1-3.672,1.578,3.672,3.672,0,0,1-3.4-1.7h-.05v6.31H55.52V25.9q0-1.921-.1-3.943h2.34l.149,1.9h.05a4.735,4.735,0,0,1,7.578-.469A6.6,6.6,0,0,1,66.955,27.8Zm-2.711.1a4.931,4.931,0,0,0-.789-2.883,2.725,2.725,0,0,0-2.317-1.183,2.767,2.767,0,0,0-1.786.653A3.028,3.028,0,0,0,58.306,26.2a3.484,3.484,0,0,0-.124.811v2a3.2,3.2,0,0,0,.8,2.207,2.656,2.656,0,0,0,2.082.9,2.724,2.724,0,0,0,2.34-1.158A5.1,5.1,0,0,0,64.244,27.9Z",
    transform: "translate(-39.181 -17.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9871",
    "data-name": "Path 9871",
    d: "M77.992,27.8a6.8,6.8,0,0,1-1.653,4.829,4.824,4.824,0,0,1-3.671,1.578,3.669,3.669,0,0,1-3.4-1.7h-.05v6.31H66.558V25.9q0-1.921-.1-3.943H68.8l.149,1.9H69a4.736,4.736,0,0,1,7.579-.469A6.618,6.618,0,0,1,77.992,27.8Zm-2.711.1a4.931,4.931,0,0,0-.79-2.883,2.721,2.721,0,0,0-2.315-1.183,2.771,2.771,0,0,0-1.787.653A3.026,3.026,0,0,0,69.342,26.2a3.553,3.553,0,0,0-.124.811v2a3.21,3.21,0,0,0,.8,2.207,2.662,2.662,0,0,0,2.084.9,2.724,2.724,0,0,0,2.34-1.158A5.1,5.1,0,0,0,75.281,27.9Z",
    transform: "translate(-36.442 -17.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9872",
    "data-name": "Path 9872",
    d: "M90.088,30.2a4.427,4.427,0,0,1-1.475,3.45A6.539,6.539,0,0,1,84.088,35.1a7.92,7.92,0,0,1-4.3-1.035l.617-2.218a7.3,7.3,0,0,0,3.847,1.061,3.637,3.637,0,0,0,2.343-.679,2.217,2.217,0,0,0,.836-1.815,2.314,2.314,0,0,0-.69-1.7,6.416,6.416,0,0,0-2.292-1.284q-4.362-1.627-4.361-4.763a4.215,4.215,0,0,1,1.529-3.356A6.028,6.028,0,0,1,85.678,18a8.062,8.062,0,0,1,3.769.789l-.665,2.169A6.54,6.54,0,0,0,85.6,20.2a3.218,3.218,0,0,0-2.192.69,1.972,1.972,0,0,0-.665,1.5,2.03,2.03,0,0,0,.763,1.626A8.62,8.62,0,0,0,85.925,25.3a8.2,8.2,0,0,1,3.154,2.02A4.219,4.219,0,0,1,90.088,30.2Z",
    transform: "translate(-33.135 -18.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9873",
    "data-name": "Path 9873",
    d: "M96.538,24.5H93.605v5.815q0,2.219,1.553,2.218a4.733,4.733,0,0,0,1.182-.124l.074,2.021a6.029,6.029,0,0,1-2.069.295,3.193,3.193,0,0,1-2.465-.961,4.721,4.721,0,0,1-.887-3.229V24.5H89.244v-2h1.747V20.306l2.614-.789V22.5h2.933v2Z",
    transform: "translate(-30.787 -17.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9874",
    "data-name": "Path 9874",
    d: "M108.024,27.847a6.57,6.57,0,0,1-1.578,4.535,5.633,5.633,0,0,1-4.389,1.824,5.356,5.356,0,0,1-4.2-1.749,6.369,6.369,0,0,1-1.565-4.411,6.506,6.506,0,0,1,1.614-4.558,5.585,5.585,0,0,1,4.349-1.775,5.47,5.47,0,0,1,4.239,1.75A6.3,6.3,0,0,1,108.024,27.847Zm-2.761.086a5.387,5.387,0,0,0-.714-2.842,2.629,2.629,0,0,0-2.389-1.433,2.668,2.668,0,0,0-2.44,1.433,5.491,5.491,0,0,0-.714,2.892,5.38,5.38,0,0,0,.714,2.841,2.72,2.72,0,0,0,4.805-.025A5.407,5.407,0,0,0,105.263,27.933Z",
    transform: "translate(-29.038 -17.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9875",
    "data-name": "Path 9875",
    d: "M113.9,24.3a4.62,4.62,0,0,0-.839-.074,2.514,2.514,0,0,0-2.169,1.061,3.988,3.988,0,0,0-.665,2.365v6.285h-2.66l.025-8.206q0-2.071-.1-3.771H109.8l.1,2.292h.074a4.1,4.1,0,0,1,1.331-1.9,3.218,3.218,0,0,1,1.923-.642,4.272,4.272,0,0,1,.665.049V24.3Z",
    transform: "translate(-26.259 -17.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9876",
    "data-name": "Path 9876",
    d: "M124.272,27.383a6.241,6.241,0,0,1-.1,1.207h-7.983A3.475,3.475,0,0,0,117.35,31.3a3.955,3.955,0,0,0,2.611.838,8.83,8.83,0,0,0,3.23-.567l.417,1.847a9.987,9.987,0,0,1-4.015.74,5.817,5.817,0,0,1-4.376-1.639,6.053,6.053,0,0,1-1.589-4.4,6.862,6.862,0,0,1,1.48-4.51,5.1,5.1,0,0,1,4.188-1.921,4.464,4.464,0,0,1,3.921,1.921A6.478,6.478,0,0,1,124.272,27.383Zm-2.538-.69a3.615,3.615,0,0,0-.517-2.046,2.325,2.325,0,0,0-2.121-1.11,2.524,2.524,0,0,0-2.118,1.085,3.971,3.971,0,0,0-.788,2.069h5.543Z",
    transform: "translate(-24.735 -17.085)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7673",
    "data-name": "Group 7673",
    transform: "translate(54.515 8.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7672",
    "data-name": "Group 7672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9877",
    "data-name": "Path 9877",
    d: "M50.384,10.794a4.1,4.1,0,0,1-1.321,3.318,5.253,5.253,0,0,1-3.474,1.028,16.106,16.106,0,0,1-1.913-.1V7.016a14.12,14.12,0,0,1,2.253-.17,4.857,4.857,0,0,1,3.233.932A3.768,3.768,0,0,1,50.384,10.794ZM49,10.83a2.983,2.983,0,0,0-.756-2.192,2.982,2.982,0,0,0-2.211-.763,5.536,5.536,0,0,0-1.053.085v6.1a6.907,6.907,0,0,0,.884.036,3.094,3.094,0,0,0,2.318-.835A3.344,3.344,0,0,0,49,10.83Z",
    transform: "translate(-43.676 -6.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9878",
    "data-name": "Path 9878",
    d: "M56.055,11.636a3.227,3.227,0,0,1-.775,2.228,2.766,2.766,0,0,1-2.156.9,2.629,2.629,0,0,1-2.064-.86,3.132,3.132,0,0,1-.768-2.167,3.2,3.2,0,0,1,.793-2.239,2.749,2.749,0,0,1,2.137-.871,2.691,2.691,0,0,1,2.083.859A3.107,3.107,0,0,1,56.055,11.636Zm-1.357.042a2.661,2.661,0,0,0-.351-1.4,1.292,1.292,0,0,0-1.173-.7,1.312,1.312,0,0,0-1.2.7,2.7,2.7,0,0,0-.351,1.42,2.661,2.661,0,0,0,.351,1.4,1.32,1.32,0,0,0,1.187.7,1.305,1.305,0,0,0,1.173-.716A2.645,2.645,0,0,0,54.7,11.679Z",
    transform: "translate(-42.034 -6.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9879",
    "data-name": "Path 9879",
    d: "M64.46,8.719,62.619,14.6h-1.2l-.763-2.555a19.121,19.121,0,0,1-.473-1.9h-.024a13.917,13.917,0,0,1-.473,1.9l-.81,2.555H57.666L55.935,8.719h1.344l.665,2.8q.242.992.4,1.888h.024q.146-.738.486-1.876l.835-2.808h1.066l.8,2.748q.29,1.005.472,1.937h.036a18.51,18.51,0,0,1,.4-1.937l.714-2.748H64.46Z",
    transform: "translate(-40.634 -6.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9880",
    "data-name": "Path 9880",
    d: "M69.223,14.627H67.915v-3.37q0-1.558-1.186-1.558a1.18,1.18,0,0,0-.945.428,1.519,1.519,0,0,0-.363,1.009v3.49H64.113v-4.2q0-.775-.047-1.684h1.15l.061.92h.036a1.89,1.89,0,0,1,.678-.71,2.211,2.211,0,0,1,1.186-.331,1.878,1.878,0,0,1,1.369.533,2.59,2.59,0,0,1,.678,1.95Z",
    transform: "translate(-38.616 -6.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9881",
    "data-name": "Path 9881",
    d: "M71.348,15.14H70.041V6.556h1.307Z",
    transform: "translate(-37.133 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9882",
    "data-name": "Path 9882",
    d: "M78.4,11.636a3.227,3.227,0,0,1-.775,2.228,2.768,2.768,0,0,1-2.156.9,2.626,2.626,0,0,1-2.064-.86,3.132,3.132,0,0,1-.768-2.167,3.2,3.2,0,0,1,.793-2.239,2.748,2.748,0,0,1,2.136-.871,2.694,2.694,0,0,1,2.084.859A3.107,3.107,0,0,1,78.4,11.636Zm-1.358.042a2.661,2.661,0,0,0-.351-1.4,1.29,1.29,0,0,0-1.172-.7,1.31,1.31,0,0,0-1.2.7,2.7,2.7,0,0,0-.351,1.42,2.661,2.661,0,0,0,.351,1.4,1.32,1.32,0,0,0,1.187.7,1.3,1.3,0,0,0,1.172-.716A2.633,2.633,0,0,0,77.046,11.679Z",
    transform: "translate(-36.487 -6.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9883",
    "data-name": "Path 9883",
    d: "M83.29,14.627H82.116l-.1-.678h-.036a2.014,2.014,0,0,1-1.719.811,1.774,1.774,0,0,1-1.343-.533,1.671,1.671,0,0,1-.461-1.2,1.828,1.828,0,0,1,.9-1.646,4.684,4.684,0,0,1,2.538-.557v-.11q0-1.163-1.222-1.162a2.737,2.737,0,0,0-1.534.436l-.266-.859A3.773,3.773,0,0,1,80.9,8.623q2.307,0,2.309,2.434v2.167A9.189,9.189,0,0,0,83.29,14.627ZM81.932,12.6V11.7q-2.164-.037-2.164,1.186a.886.886,0,0,0,.251.69.915.915,0,0,0,.639.23,1.321,1.321,0,0,0,.8-.272,1.117,1.117,0,0,0,.474-.926Z",
    transform: "translate(-35.043 -6.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9884",
    "data-name": "Path 9884",
    d: "M89.4,15.14H88.241l-.061-.945h-.036a1.956,1.956,0,0,1-1.89,1.078,2.215,2.215,0,0,1-1.767-.835,3.253,3.253,0,0,1-.7-2.167,3.411,3.411,0,0,1,.763-2.313,2.345,2.345,0,0,1,1.816-.824,1.763,1.763,0,0,1,1.658.8h.025V6.556h1.309v7Q89.356,14.414,89.4,15.14Zm-1.356-2.481v-.981a1.925,1.925,0,0,0-.036-.412,1.49,1.49,0,0,0-.473-.793,1.286,1.286,0,0,0-.875-.321,1.342,1.342,0,0,0-1.151.582,2.493,2.493,0,0,0-.419,1.489,2.324,2.324,0,0,0,.4,1.417,1.346,1.346,0,0,0,1.143.58,1.26,1.26,0,0,0,1.033-.484A1.612,1.612,0,0,0,88.046,12.658Z",
    transform: "translate(-33.722 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9885",
    "data-name": "Path 9885",
    d: "M98.394,11.636a3.227,3.227,0,0,1-.775,2.228,2.765,2.765,0,0,1-2.156.9A2.633,2.633,0,0,1,93.4,13.9a3.132,3.132,0,0,1-.768-2.167,3.2,3.2,0,0,1,.793-2.239,2.75,2.75,0,0,1,2.138-.871,2.688,2.688,0,0,1,2.082.859A3.107,3.107,0,0,1,98.394,11.636Zm-1.355.042a2.661,2.661,0,0,0-.351-1.4,1.294,1.294,0,0,0-1.175-.7,1.315,1.315,0,0,0-1.2.7,2.7,2.7,0,0,0-.351,1.42,2.661,2.661,0,0,0,.351,1.4,1.337,1.337,0,0,0,2.362-.012A2.656,2.656,0,0,0,97.038,11.679Z",
    transform: "translate(-31.526 -6.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9886",
    "data-name": "Path 9886",
    d: "M103.908,14.627H102.6v-3.37q0-1.558-1.187-1.558a1.176,1.176,0,0,0-.944.428,1.513,1.513,0,0,0-.363,1.009v3.49H98.8v-4.2q0-.775-.046-1.684H99.9l.061.92H100a1.909,1.909,0,0,1,.678-.71,2.215,2.215,0,0,1,1.187-.331,1.877,1.877,0,0,1,1.368.533,2.585,2.585,0,0,1,.678,1.95Z",
    transform: "translate(-30.007 -6.044)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9887",
    "data-name": "Path 9887",
    d: "M110.649,9.99h-1.44v2.858c0,.726.256,1.09.763,1.09a2.3,2.3,0,0,0,.583-.061l.034.992a2.939,2.939,0,0,1-1.016.146,1.564,1.564,0,0,1-1.209-.472,2.308,2.308,0,0,1-.437-1.586V9.99h-.86V9.01h.86V7.932l1.282-.387V9.009h1.44V9.99Z",
    transform: "translate(-27.944 -6.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9888",
    "data-name": "Path 9888",
    d: "M116.5,15.14h-1.309V11.795q0-1.582-1.185-1.583a1.249,1.249,0,0,0-1.248.917,1.644,1.644,0,0,0-.061.471v3.539H111.39V6.556H112.7V10.1h.025a1.977,1.977,0,0,1,1.767-.967,1.823,1.823,0,0,1,1.346.533,2.68,2.68,0,0,1,.665,1.973v3.5Z",
    transform: "translate(-26.871 -6.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9889",
    "data-name": "Path 9889",
    d: "M122.247,11.409A3.158,3.158,0,0,1,122.2,12h-3.923a1.715,1.715,0,0,0,.568,1.332,1.949,1.949,0,0,0,1.284.412,4.334,4.334,0,0,0,1.586-.278l.2.909a4.926,4.926,0,0,1-1.975.363,2.852,2.852,0,0,1-2.148-.805,2.966,2.966,0,0,1-.78-2.161,3.367,3.367,0,0,1,.726-2.216,2.5,2.5,0,0,1,2.057-.944,2.188,2.188,0,0,1,1.923.944A3.141,3.141,0,0,1,122.247,11.409ZM121,11.07a1.761,1.761,0,0,0-.253-1A1.143,1.143,0,0,0,119.7,9.52a1.242,1.242,0,0,0-1.041.533,1.98,1.98,0,0,0-.388,1.017H121Z",
    transform: "translate(-25.475 -6.045)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIstoreIcon);
export default __webpack_public_path__ + "static/media/istore-icon.dfcf7bf08d79ca3d81cdbc74b994c586.svg";
export { ForwardRef as ReactComponent };